import { LeadFormData } from "../blocks/LeadForm/LeadFormModal";

interface GetPdfDownloadLink {
  (
    params: Partial<LeadFormData> & {
      /** A one-time `pdf` hand-off code (createHandoffCode); Express exchanges it for the token. */
      code: string;
      filename: string;
      orientation: "landscape" | "portrait";
      path: string;
    }
  ): string;
}

export const getPdfDownloadLink: GetPdfDownloadLink = ({
  code,
  filename,
  orientation,
  path,
  ...leadFormData
}) => {
  const queryString = new URLSearchParams({
    ...leadFormData,
    code,
    filename,
    orientation,
    url: `${window.location.origin}${path}`,
  }).toString();

  return `/pdf?${queryString}`;
};
